import * as ActionTypes from "../ActionTypes";
import * as URL from "../API_URL";
import {
  getRequest,
  postRequest,
  getRequest1,
  getRequest2,
  postRequest1,
  postRequest2,
  postRequest3,
  postRequest4,
  uploadPostRequest,
  fetchcampaign,
} from "./index";
import store from "../../index";

export const login = (loginData, username, pwd, customerId) => {
  return postRequest2(
    URL.LOGIN,
    loginData,
    ActionTypes.LOGIN,
    username,
    pwd,
    customerId
  );
};

export const signUp = (signUpData) => {
  return postRequest(URL.SIGNUP, signUpData, ActionTypes.SIGNUP);
};
export const getCampaignList = (
  enrlCampaignId = "",
  planCampaignName = "",
  campaignOwner = "",
  status = "",
  customerId = ""
) => {
  return fetchcampaign(
    URL.GET_CAMPAIGN_LIST,
    { enrlCampaignId, planCampaignName, campaignOwner, status },
    ActionTypes.CAMPAIGN_LIST,
    customerId
  );
};
export const searchCampaign = (
  planCampaignName,
  enrlCampaignId,
  campaignOwner,
  status,
  customerId
) => {
  return fetchcampaign(
    URL.GET_CAMPAIGN_LIST,
    { planCampaignName, enrlCampaignId, campaignOwner, status },
    ActionTypes.CAMPAIGN_LIST,
    customerId
  );
};
export const getAgentList = (customerId) => {
  return getRequest1(
    `${URL.GET_AGENT_IN_FORM + customerId}`,
    ActionTypes.GET_AGENT_LIST
  );
};
export const getltcList = (customerId) => {
  return getRequest1(URL.GET_LTC_LIST, ActionTypes.GET_LTC_LIST, customerId);
};

export const loadDemographics = (payload) => {
  return postRequest(
    URL.LOAD_DEMOGRAPHICS,
    payload,
    ActionTypes.LOAD_DEMOGRAPHICS
  );
};
export const loadSoa = (payload) => {
  return postRequest(URL.LOAD_SOA, payload, ActionTypes.LOAD_SOA);
};
export const loadCallsData = (payload) => {
  return postRequest(URL.GET_CALLS_DATA, payload, ActionTypes.GET_CALLS_DATA);
};
export const getCallsDataOnRowSelect = (payload) => {
  return postRequest(
    URL.GET_CALLS_DATA_ROWSELECT,
    payload,
    ActionTypes.GET_CALLS_DATA_ROWSELECT
  );
};

export const getAgentIDListInPreEnrollForm = (customerId) => {
  let url = URL.GET_AGENT_IN_FORM + customerId;
  return getRequest(url, ActionTypes.GET_AGENT_IN_FORM);
};
export const getStates = () => {
  let url = URL.GET_STATES;
  return getRequest(url, ActionTypes.GET_STATES);
};
export const getAuthrelations = (customerId) => {
  let url = URL.GET_AUTH_RELATIONS;
  return getRequest2(url, ActionTypes.GET_AUTH_RELATIONS, customerId);
};
export const getCityList = (payload) => {
  return postRequest(URL.GET_CITY_LIST, payload, ActionTypes.GET_CITY_LIST);
};
export const searchProspect = (payload) => {
  return postRequest(URL.SEARCH_PROSPECT, payload, ActionTypes.SEARCH_PROSPECT);
};

export const loadprospectrowData = (payload) => {
  return postRequest(URL.LOAD_PROSPECT, payload, ActionTypes.LOAD_PROSPECT_ROW);
};
export const guestLogin = (email) => {
  let url = URL.GUEST_LOGIN;
  return postRequest(url, email, ActionTypes.GUEST_LOGIN);
};

export const agentStatusDashboard = (
  data,
  customerId,
  emailId,
  agentId,
  agencyId
) => {
  let url = URL.STATUS_DASHBOARD;
  return postRequest1(
    url,
    data,
    ActionTypes.STATUS_DASHBOARD,
    customerId,
    emailId,
    agentId,
    agencyId
  );
};
export const RapidDisEnrollmentByMonth = (data) => {
  let url = URL.RAPID_DISENROLLMENT_BYMONTH;
  return postRequest1(url, data, ActionTypes.RAPID_DISENROLLMENT_BYMONTH);
};
export const agentCategoryDashboard = (
  data,
  customerId,
  emailId,
  agentId,
  agencyId,
  userId
) => {
  let url = URL.CATEGORY_DASHBOARD;
  return postRequest1(
    url,
    data,
    ActionTypes.CATEGORY_DASHBOARD,
    customerId,
    emailId,
    agentId,
    agencyId,
    userId
  );
};
export const checkEligibility = (checkFields) => {
  return postRequest(
    URL.CHECKELIGIBILITY,
    checkFields,
    ActionTypes.SET_ELIGIBILITY
  );
};
export const comparePlan = (list) => {
  let url = URL.COMPARE_PLAN;
  return postRequest(url, list, ActionTypes.COMPARE_PLAN);
};
export const getcmpNames = (data) => {
  return {
    type: ActionTypes.GET_CMP_NAMES,
    payload: data,
  };
};
export const getPlanDetails = (customerId, productId, planYear) => {
  let url = URL.PLAN_DETAILS;
  return postRequest(
    url,
    { customerId, productId, planYear },
    ActionTypes.GET_PLAN_DETAILS
  );
};

export const yearSelection = (year) => {
  return { payload: year, type: ActionTypes.YEAR_SELECTION };
};
export const searchExistingApplication = (searchVo, custId, emailId) => {
  return postRequest1(
    URL.SEARCH_EXISTING_APP,
    searchVo,
    ActionTypes.SEARCH_APPLICATION,
    custId,
    emailId
  );
};

export const planSelectionContinue = (plan, customerId) => {
  return postRequest4(
    URL.PLAN_SELECTION_CONTINUE,
    plan,
    ActionTypes.PLAN_SELECTION_CONTINUE,
    "",
    customerId
  );
};

export const saveLogout = (data) => {
  const preEnrollInfo = store.getState().webApp.preEnrollInfo;
  return postRequest(
    URL.SAVE_LOGOUT,
    data,
    ActionTypes.SAVE_LOGOUT,
    preEnrollInfo
  );
};

export const submitForm = (payload) => {
  return postRequest(URL.SUBMIT_FORM, payload, ActionTypes.SUBMIT_FORM);
};

export const submitEnroll = (payload) => {
  return postRequest(URL.SAVE_ENROLL, payload, ActionTypes.SAVE_ENROLL_FORM);
};

export const submitCampaignOwner = (payload) => {
  return postRequest(
    URL.SAVE_CAMPAIGN_OWNER,
    payload,
    ActionTypes.SAVE_CAMPAIGN_OWNER_FORM
  );
};

export const downloadPdf = () => {
  return getRequest(URL.DOWNLOAD_PDF, ActionTypes.DOWNLOAD_PDF);
};

export const getClinicalName = (name) => {
  return getRequest(
    `${URL.GET_CLINICAL_NAME}${name}`,
    ActionTypes.GET_CLINICAL_NAME
  );
};

export const sendLink = (email) => {
  return getRequest(
    `${URL.FORGOT_LOGIN_DETAIL}${email}`,
    ActionTypes.FORGOT_LOGIN_DETAIL
  );
};

export const resetPassword = (data) => {
  return postRequest(URL.RESET_LOGIN, data, ActionTypes.RESET_LOGIN);
};

export const uploadPDF = (data) => {
  return postRequest(URL.PDF_UPLOAD, data, ActionTypes.PDF_UPLOAD);
};

export const removeplan = () => {
  return {
    type: ActionTypes.REMOVEPLAN,
  };
};
export const savelang = (data) => {
  return {
    type: ActionTypes.SAVE_LANGUAGE,
    payload: data,
  };
};

export const getPlans = (zipcode, county, customerId, stateCd, planYear) => {
  let url = URL.PLAN_SUMMARY;
  let body = {
    zipCd: zipcode,
    countyCd: county,
    customerId: customerId,
    stateCd: stateCd,
    planYear: planYear,
  };
  return postRequest4(
    url,
    body,
    ActionTypes.GET_PLAN_SUMMARY_BY_ZIP,
    "",
    customerId
  );
};
export const getPlansEmail = (
  zipcode,
  county,
  customerId,
  stateCd,
  year,
  token
) => {
  let url = URL.PLAN_SUMMARY;
  let body = {
    zipCd: zipcode,
    countyCd: county,
    customerId: customerId,
    stateCd: stateCd,
    planYear: year,
  };
  return postRequest3(url, body, ActionTypes.GET_PLAN_SUMMARY_BY_ZIP, token);
};

export const getPlanSummaryById = (planId, zip, county) => {
  let url = URL.PLAN_SUMMARY_BY_ID + "/" + planId + "/" + zip + "/" + county;
  return getRequest(url, ActionTypes.GET_PLAN_SUMMARY);
};

export const setEnrollRedirect = (applId, email, customerId) => {
  let url = URL.SET_ENROLLMENT_REDIRECT;
  return postRequest(
    url,
    { appNumber: applId, emailAddress: email, customerId: customerId },
    ActionTypes.SET_ENROLLMENT_REDIRECT
  );
};

export const getPcpList = (payload) => {
  return postRequest(URL.GET_PCPS, payload, ActionTypes.GET_PCPS);
};

export const setFormData = (data) => {
  return {
    type: ActionTypes.SET_FORM_DATA,
    payload: data,
  };
};
export const setStateParams = (type, data) => {
  return {
    type: ActionTypes.SET_ZIP,
    payload: { type: type, data: data },
  };
};
export const setStateParamsCalendar = (type, data) => {
  return {
    type: ActionTypes.SET_CALENDER_PARAMETER,
    payload: { type: type, data: data },
  };
};
export const setBulkStateParams = (type, data) => {
  return {
    type: ActionTypes.SET_BULK_STATE_PARAMS,
    payload: { type: type, data: data },
  };
};
export const setLoginStateParams = (type, data) => {
  return {
    type: ActionTypes.SET_LOGIN_STATE_PARAMS,
    payload: { type: type, data: data },
  };
};
export const setCampaignProspectStateParams = (type, data) => {
  return {
    type: ActionTypes.SET_CAMPAIGN_PROSPECT_STATE_PARAMS,
    payload: { type: type, data: data },
  };
};
export const setSpinner = (data) => {
  return {
    type: "SET_SPINNER",
    payload: data,
  };
};
export const guestLogout = () => {
  return {
    type: ActionTypes.LOGOUT,
    payload: [],
  };
};
export const resetStore = () => {
  return {
    type: ActionTypes.RESET_STORE,
  };
};
export const getZipCodes = (zipcode) => {
  let url = URL.GET_ZIPCODES + zipcode;
  return getRequest(url, ActionTypes.GET_ZIPCODES);
};
export const getMailZipCodes = (zipcode) => {
  let url = URL.GET_ZIPCODES + zipcode;
  return getRequest(url, ActionTypes.GET_MAILZIPCODES);
};

export const agentLogin = (isLoggedIn, agentId) => {
  return {
    type: ActionTypes.AGENT_LOGIN,
    payload: isLoggedIn,
    agentId: agentId,
  };
};

export const sendEmail = (data) => {
  return postRequest(URL.EMAIL_PLAN, data, ActionTypes.EMAIL_PLAN);
};

export const emailProgress = (data) => {
  return postRequest(URL.EMAIL_SHARP_PLAN, data, ActionTypes.EMAIL_PLAN);
};

export const successfulSignUp = (isSuccessful) => {
  return {
    type: ActionTypes.SUCCESSFUL_SIGNUP,
    payload: isSuccessful,
  };
};

export const setTokenTORedux = (payload) => {
  return {
    type: ActionTypes.TOKEN_TO_REDUX,
    payload: payload,
  };
};
export const clearprospectrowData = () => {
  return {
    type: ActionTypes.CLEAR_PROSPECT_ROW_DATA,
  };
};
export const setLoginData = (payload) => {
  return {
    type: ActionTypes.SET_LOGIN_DATA,
    payload: payload,
  };
};

export const setEmail = (payload) => {
  return {
    type: ActionTypes.SET_EMAil,
    payload: payload,
  };
};

export const saveAgentDetails = (name, value) => {
  return {
    type: ActionTypes.SOA_DETAILS,
    payload: { name, value },
  };
};
export const saveAgentproductIds = (name, value) => {
  return {
    type: ActionTypes.SOA_PRODUCT_IDS,
    payload: { name, value },
  };
};

export const setAgentEmailId = (email) => {
  return {
    type: ActionTypes.AGENTEMAILID,
    payload: email,
  };
};

export const setDeepLink = (deeplink) => {
  return {
    type: ActionTypes.DEEPLINK,
    payload: deeplink,
  };
};
export const uploadFile = (payload, extraData) => {
  return uploadPostRequest(
    URL.UPLOAD_FILES,
    payload,
    ActionTypes.UPLOAD_FILES,
    extraData
  );
};
export const uploadSign = (payload) => {
  return postRequest(URL.DIGITAL_SIGN, payload, ActionTypes.DIGITAL_SIGN);
};
export const deleteFile = (payload) => {
  return postRequest(
    URL.DELETE_FILE,
    payload,

    ActionTypes.DELETE_FILE,
    true
  );
};

export const LogoutToken = () => {
  return {
    type: ActionTypes.REMOVETOKEN,
  };
};

export const setPendingApplFlag = (data) => {
  return {
    type: ActionTypes.SETPENDAPPLFLAG,
    payload: data,
  };
};

export const prospectManagement = (data) => {
  return {
    type: ActionTypes.SET_PROSPECT_STATE,
    payload: data,
  };
};

export const campaignManagement = (data) => {
  return {
    type: ActionTypes.SET_CAMPAIGN_STATE,
    payload: data,
  };
};
export const ForgotPwdEmail = (email, customerId) => {
  let url =
    URL.FORGET_EMAIL + "?emailId=" + email + "&customerId=" + customerId;
  return getRequest(url, ActionTypes.FORGET_EMAIL);
};
export const NewPasswordChange = (data) => {
  return postRequest(
    URL.NEW_VALUES_FOR_LOGIN,
    data,
    ActionTypes.NEW_VALUES_FOR_LOGIN
  );
};
export const submittedChart = (data, custId, email, agentId, agencyId) => {
  return postRequest1(
    URL.PIE_CHART_FILTER,
    data,
    ActionTypes.STATUS_DASHBOARD,
    custId,
    email,
    agentId,
    agencyId
  );
};
export const ProspectManagementSaveSoa = (data) => {
  return postRequest(URL.SAVE_SOA, data, ActionTypes.SAVE_SOA_DATA);
};
export const ProspectManagementSaveDemographics = (data) => {
  return postRequest(URL.SAVE_DEMOGRAPHICS, data, ActionTypes.SAVE_SOA_DATA);
};

export const ProspectManagementSaveProspect = (data) => {
  return postRequest(URL.SAVE_PROSPECT, data, ActionTypes.SAVE_PROSPECT);
};
export const ProspectManagementSaveCalls = (data) => {
  return postRequest(URL.SAVE_CALLS, data, ActionTypes.SAVE_CALLS);
};

export const setCallerId = (callerId) => {
  return {
    type: ActionTypes.SET_CALLER_ID,
    payload: callerId,
  };
};
export const setProspectRowData = (leadIdNbr) => {
  return {
    type: ActionTypes.SET_LEAD_ID,
    payload: leadIdNbr,
  };
};

export const getCommentsData = (callerID) => {
  return postRequest(
    URL.GET_COMMENTS_DATA,
    callerID,
    ActionTypes.GET_COMMENTS_DATA
  );
};

export const addNewComment = (callerID) => {
  return postRequest(
    URL.ADD_NEW_COMMENT,
    callerID,
    ActionTypes.ADD_NEW_COMMENT
  );
};

export const getAgencyId = (agentId, customerId) => {
  let url = URL.GET_AGENCY_ID + agentId;
  return getRequest1(url, ActionTypes.GET_AGENCYID, customerId);
};

export const keyPerformanceByAgent = (payload) => {
  return postRequest(
    URL.KEY_PERFORMANCE_BY_AGENT,
    payload,
    ActionTypes.KEY_PERFORMANCE_BY_AGENT
  );
};

export const setKeyPerformanceByAgent = (data) => {
  return {
    type: ActionTypes.KEY_PERFORMANCE_BY_AGENT_STATE,
    payload: data,
  };
};

export const keyPerformanceByCampaign = (payload) => {
  return postRequest(
    URL.KEY_PERFORMANCE_BY_CAMPAIGN,
    payload,
    ActionTypes.KEY_PERFORMANCE_BY_CAMPAIGN
  );
};

export const setKeyPerformanceByCampaign = (data) => {
  return {
    type: ActionTypes.KEY_PERFORMANCE_BY_CAMPAIGN_STATE,
    payload: data,
  };
};
export const getPCPsWithCoords = (searchVO) => {
  return postRequest(URL.PCP_MAP_POPUP, searchVO, ActionTypes.PCP_MAP_SEARCH);
};
export const setPcpData = (selectedVo) => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.SET_PCP_DATA,
      selectedVo: selectedVo,
    });
  };
};
export const searchAndSetPcp = (searchVO) => {
  return postRequest(URL.PCP_POPUP, searchVO, ActionTypes.PCP_SEARCH_AND_SET);
};
export const loadCampaignNames = () => {
  return getRequest(URL.GET_CAMPAIGN_NAMES, ActionTypes.GET_CAMPAIGN_NAMES);
};
export const loadCampaignOwnerNames = () => {
  return getRequest(
    URL.GET_CAMPAIGN_OWNER_NAMES,
    ActionTypes.GET_CAMPAIGN_OWNER_NAMES
  );
};
export const loadAppList = (data) => {
  return postRequest(URL.PENDING_APP_LIST, data, ActionTypes.PENDING_APP_LIST);
};
export const getCustomerSubdomain = () => {
  let url = URL.GET_CUSTOMER_SUBDOMAIN;
  return getRequest(url, ActionTypes.GET_CUSTOMER_SUBDOMAIN);
};
export const getMembershipAgentList = (customerId) => {
  let url = URL.MEMBERSHIP_AGENT_lIST + customerId;
  return getRequest(url, ActionTypes.MEMBERSHIP_AGENT_lIST);
};
export const clearProspectData = () => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.CLEAR_PROSPECT_DATA,
    });
  };
};
export const clearSoaData = () => {
  return async (dispatch) => {
    dispatch({
      type: ActionTypes.CLEAR_SOA_DATA,
    });
  };
};
export const captchaValidation = (data) => {
  return {
    type: ActionTypes.CAPTCHA,
    payload: data,
  };
};
export const setPageName = (pageName) => {
  return {
    type: ActionTypes.SET_PAGE_NAME,
    payload: pageName,
  };
};

export const downloadFormsPdf = (payload) => {
  return postRequest(
    URL.DOWNLOAD_FORMS_PDF,
    payload,
    ActionTypes.DOWNLOAD_FORMS_PDF
  );
};
export const SoapdfDownload = (payload) => {
  return postRequest(
    URL.DOWNLOAD_SOA_PDF,
    payload,
    ActionTypes.DOWNLOAD_SOA_PDF
  );
};
export const setCategoryName = (productCategory, selectedPlanName) => {
  return {
    type: ActionTypes.SET_CATEGORY_NAME,
    payload: {
      productCategory: productCategory,
      selectedPlanName: selectedPlanName,
    },
  };
};
export const assignProspect = (data) => {
  return postRequest(URL.ASSIGN_PROSPECT, data, ActionTypes.ASSIGN_PROSPECT);
};
export const setLoginStateValues = (data) => {
  return {
    type: ActionTypes.SET_LOGIN_VALUES,
    payload: data,
  };
};
export const prospectFileUpload = (
  data,
  customerId,
  emailId,
  agentId,
  agencyId
) => {
  let url = URL.PROSPECT_FILE_UPLOAD;
  return postRequest1(
    url,
    data,
    ActionTypes.PROSPECT_FILE_UPLOAD,
    customerId,
    emailId,
    agentId,
    agencyId
  );
};

export const campaignFileUpload = (
  data,
  customerId,
  emailId,
  agentId,
  agencyId
) => {
  let url = URL.CAMPAIGN_FILE_UPLOAD;
  return postRequest1(
    url,
    data,
    ActionTypes.CAMPAIGN_FILE_UPLOAD,
    customerId,
    emailId,
    agentId,
    agencyId
  );
};
export const getsepReasons = (payload) => {
  let url = URL.GET_SEP_REASONS;
  return postRequest(url, payload, ActionTypes.GET_SEP_REASONS);
};
export const loadProspectFilesData = () => {
  let url = URL.GET_PROSPECT_FILES_DATA;
  return getRequest(url, ActionTypes.GET_PROSPECT_FILES_DATA);
};

export const campaignFileTable = () => {
  let url = URL.GET_CAMPAIGN_FILES_DATA;
  return getRequest(url, ActionTypes.GET_CAMPAIGN_FILES_DATA);
};
export const campaignFileData = (payload) => {
  return postRequest(
    URL.LOAD_CAMPAIGN_FILEDATA,
    payload,
    ActionTypes.LOAD_CAMPAIGN_FILEDATA
  );
};

export const prospectFileData = (payload) => {
  return postRequest(
    URL.LOAD_PROSPECT_FILEDATA,
    payload,
    ActionTypes.LOAD_PROSPECT_FILEDATA
  );
};
export const updateProspectFilerecords = (payload) => {
  return postRequest(
    URL.UPDATE_PROSPECT_RECORDS,
    payload,
    ActionTypes.UPDATE_PROSPECT_RECORDS
  );
};
export const updateCampaignFilerecords = (payload) => {
  return postRequest(
    URL.UPDATE_CAMPAIGN_RECORDS,
    payload,
    ActionTypes.UPDATE_CAMPAIGN_RECORDS
  );
};
export const mbiDetails = (payload) => {
  return postRequest(URL.MBI_DETAILS, payload, ActionTypes.MBI_DETAILS);
};
export const fetchAppointments = (payload) => {
  let appoint = URL.FETCH_APPOINTMENTS + `?leadIdNbr=${payload}`;
  return getRequest(appoint, ActionTypes.FETCH_APPOINTMENTS);
};
export const loadprospectOnagent = (payload) => {
  return postRequest(
    URL.LOADPROSPECTONAGENT,
    payload,
    ActionTypes.LOADPROSPECTONAGENT
  );
};
export const fetchFileTypes = () => {
  return getRequest(
    URL.GET_FILE_ATTACHMENT_TYPES,
    ActionTypes.GET_FILE_ATTACHMENT_TYPES
  );
};
